import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BreadcrumbNavigationService, ConfigurationService, PortalConfigurationService } from '@draeger-academy/common';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
    selector: 'da-partner-portal',
    templateUrl: './partner-portal.component.html',
    styleUrls: ['./partner-portal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PartnerPortalComponent implements OnInit, OnDestroy {
    public errorMessage: string;
    private _$portalId: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    private _$loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
    private _$intro: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    private _$portalVersion: BehaviorSubject<string> = new BehaviorSubject<string>(null);

    constructor(
        private _activatedRoute: ActivatedRoute,
        private _portalConfigurationService: PortalConfigurationService,
        private _router: Router,
        private _localizeRouterService: LocalizeRouterService,
        private _configurationService: ConfigurationService,
        private _breadcrumbNavigationService: BreadcrumbNavigationService,
        private _translateService: TranslateService
    ) {
        // if (!this._configurationService.hasFeature('Partner')) {
        //     this._router.navigate(['/partner'], { skipLocationChange: true }).then();
        // }
    }

    public get portalId$(): Observable<any> {
        return this._$portalId.asObservable();
    }

    public get portalVersion$(): Observable<any> {
        return this._$portalVersion.asObservable();
    }

    public get loading$(): Observable<boolean> {
        return this._$loading.asObservable();
    }

    public get intro$(): Observable<any> {
        return this._$intro.asObservable();
    }

    public ngOnInit(): void {
        this._configurationService.getPortalVersion().subscribe((pv) => {
            this._$portalVersion.next(pv);
        });
        this._configurationService.currentPortal$.subscribe((portalId) => {
            this._$portalId.next(portalId);
            if (portalId) {
                this._$loading.next(false);
            }
        });

        this._translateService.stream(['headline', 'copyText']).subscribe((data: any) => {
            if (data) {
                const _headline = data['headline'] !== 'headline' ? data['headline'] : null;
                const _copyText = data['copyText'] !== 'copyText' ? data['copyText'] : null;
                this._$intro.next({ headline: _headline, copyText: _copyText });
            }
        });
        this._breadcrumbNavigationService.initPartnerBreadcrumb(this._$portalId.getValue());
    }

    scrollToTop() {
        window.scrollTo(0, 0);
    }

    public ngOnDestroy(): void {
        this._breadcrumbNavigationService.resetBreadcrumb();
    }
}
